import { Chip } from './chip';
import { Icon } from './icon';
import { RunStatus } from '../../../../backend/src/types/types';
import { CHIP_COLOURS } from '../lib/chip-colours';
import { isProcessingStatus } from '../lib/pipeline-status';
import { cn } from '../lib/utils';

// We only need these fields to determine the processed state
interface DocWithProcessingState {
  isProcessed: boolean;
  run?: { status: string };
}

export enum ProcessingState {
  Processing = 'processing',
  Processed = 'processed',
  NotProcessed = 'not-processed',
}
interface ProcessingChipProps {
  processingState: ProcessingState;
  processingText?: string;
}

type ProcessingStateConfig = {
  chipClass: string;
  iconClass: string;
  label?: string;
  getLabel?: (processingText: string) => string;
};

const PROCESSING_CONFIG: Record<ProcessingState, ProcessingStateConfig> = {
  [ProcessingState.Processing]: {
    chipClass: CHIP_COLOURS.processing,
    iconClass: 'lucide--loader-2 animate-spin duration-1500',
    getLabel: (processingText: string) => processingText,
  },
  [ProcessingState.Processed]: {
    chipClass: CHIP_COLOURS.default,
    iconClass: 'lucide--circle-check text-teal-500',
    label: 'Processed',
  },
  [ProcessingState.NotProcessed]: {
    chipClass: CHIP_COLOURS.default,
    iconClass: 'lucide--circle-x text-red-500',
    label: 'Not processed',
  },
};

export function getProcessingState(doc: DocWithProcessingState): ProcessingState {
  const isCurrentlyProcessing =
    doc.run && doc.run.status && !doc.isProcessed && isProcessingStatus(doc.run.status as RunStatus);
  return isCurrentlyProcessing
    ? ProcessingState.Processing
    : doc.isProcessed
      ? ProcessingState.Processed
      : ProcessingState.NotProcessed;
}

export function ProcessingChip({ processingState, processingText = 'Processing' }: ProcessingChipProps) {
  const stateConfig = PROCESSING_CONFIG[processingState];
  const label = stateConfig.getLabel ? stateConfig.getLabel(processingText) : stateConfig.label;

  return (
    <Chip className={cn(stateConfig.chipClass, 'w-fit border')}>
      <Icon className={stateConfig.iconClass} />
      <span>{label}</span>
    </Chip>
  );
}
